import(/* webpackMode: "eager" */ "/home/runner/work/wahni.io/wahni.io/src/app/services/erp-implementation/implementation.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/wahni.io/wahni.io/src/components/ServicesHero.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/wahni.io/wahni.io/src/components/Timeline.jsx");
